import {
  getServiceRequestSalesTaxFlow,
  getServiceRequestServiceId,
  TSalesTaxFlow,
} from '@commenda/types';
import { CA_CORP_INCORPORATION_COMPONENT_MAP } from './CA_INCORP/componentMap';
import { COMPLIANCE_FILINGS_BY_COMMENDA_DEFAULT_COMPONENT_MAP } from './COMPLIANCE_FILING_DEFAULT/byCommendaComponentMap';
import { IND_LLP_INCORPORATION_COMPONENT_MAP } from './IN_INCORP/IN_LLP/componentMap';
import { IND_PVT_INCORPORATION_COMPONENT_MAP } from './IN_INCORP/IN_PVT_LTD/componentMap';
import { INCORPORATION_DEFAULT_COMPONENT_MAP } from './INCORPORATION_DEFAULT/componentMap';
import { SALES_TAX_FILING_COMPONENT_MAP } from './sales-tax-filing/index';
import { TA_ONBOARDING_COMPONENT_MAP } from './TA_ONBOARDING/componentMap';
import { US_CCORP_INCORPORATION_COMPONENT_MAP } from './US_INCORP/CCORP/componentMap';
import { US_LLC_INCORPORATION_COMPONENT_MAP } from './US_INCORP/LLC/componentMap';
import { VAT_RETURN_FILING_DEFAULT_COMPONENT_MAP } from './vat-return-filings/componentMap';

export const SalesTaxFlowComponentMap: Record<TSalesTaxFlow, object | null> = {
  SALES_TAX_FILING: SALES_TAX_FILING_COMPONENT_MAP,
  SALES_TAX_REGISTRATION: null,
};

export const ServiceComponentMap: Record<string, object | null> = {
  EM_INC_IN_PVTLTD: IND_PVT_INCORPORATION_COMPONENT_MAP,
  EM_INC_IN_LLP: IND_LLP_INCORPORATION_COMPONENT_MAP,
  EM_INC_US_LLC: US_LLC_INCORPORATION_COMPONENT_MAP,
  EM_INC_US_CCORP: US_CCORP_INCORPORATION_COMPONENT_MAP,
  EM_INC_CA: CA_CORP_INCORPORATION_COMPONENT_MAP,
  EM_INC_AE: INCORPORATION_DEFAULT_COMPONENT_MAP,
  EM_INC_GB: INCORPORATION_DEFAULT_COMPONENT_MAP,
  EM_INC_IE: INCORPORATION_DEFAULT_COMPONENT_MAP,
  EM_INC_SG: INCORPORATION_DEFAULT_COMPONENT_MAP,
  OB_TNA_US: TA_ONBOARDING_COMPONENT_MAP,
  OB_TNA_IN: TA_ONBOARDING_COMPONENT_MAP,
  OB_TNA_CA: TA_ONBOARDING_COMPONENT_MAP,
  OB_TNA_GB: TA_ONBOARDING_COMPONENT_MAP,
  OB_TNA_SG: TA_ONBOARDING_COMPONENT_MAP,
  OB_TNA_IE: null,
  TP_BEN: null,
  TP_POL: null,
  IT_FIL_GB_VAT: VAT_RETURN_FILING_DEFAULT_COMPONENT_MAP,
  IT_FIL_DE_VAT: VAT_RETURN_FILING_DEFAULT_COMPONENT_MAP,
};

// A sales-tax request takes its flow's tasks whatever its service, which requests made another way can share.
export const getServiceRequestComponentMap = (
  serviceRequest: Parameters<typeof getServiceRequestServiceId>[0] &
    Parameters<typeof getServiceRequestSalesTaxFlow>[0] & {
      isCommendaFiling?: boolean;
    }
): object | null | undefined => {
  const salesTaxFlow = getServiceRequestSalesTaxFlow(serviceRequest);
  if (salesTaxFlow) return SalesTaxFlowComponentMap[salesTaxFlow];
  const serviceId = getServiceRequestServiceId(serviceRequest);
  if (serviceId && serviceId in ServiceComponentMap) {
    return ServiceComponentMap[serviceId];
  }
  return serviceRequest?.isCommendaFiling
    ? COMPLIANCE_FILINGS_BY_COMMENDA_DEFAULT_COMPONENT_MAP
    : null;
};
